import React, { Component } from 'react';
import PropTypes from 'prop-types';

class NavLines extends Component {
    static propTypes = {
        tabs: PropTypes.arrayOf(
            PropTypes.shape({
                name: PropTypes.string.isRequired,
                label: PropTypes.string.isRequired,
            })
        ).isRequired,
        onChange: PropTypes.func.isRequired,
        activeTab: PropTypes.string,
    };

    constructor() {
        super();
        this.state = { activeTab: '' };
    }

    _handleClick(name) {
        this.setState({ activeTab: name });
        this.props.onChange(name);
    }

    _getActiveTab() {
        if (this.state.activeTab) {
            return this.state.activeTab;
        }
        if (this.props.activeTab) {
            return this.props.activeTab;
        }
        if (this.props.tabs.length > 0) {
            return this.props.tabs[0].name;
        }
        return '';
    }

    _renderTab(tab) {
        return (
            <li className="nav-item text-sm" key={String(Math.random())}>
                <a
                    className={
                        'cursor-pointer' +
                        (this._getActiveTab() === tab.name ? ' active' : '')
                    }
                    role="tab"
                    onClick={() => this._handleClick(tab.name)}
                >
                    {tab.label}
                </a>
            </li>
        );
    }

    render() {
        return (
            <ul className="nav nav-lines">
                {this.props.tabs.map((tab, i) => this._renderTab(tab))}
            </ul>
        );
    }
}

export default NavLines;



// WEBPACK FOOTER //
// ./app/components/NavLines.jsx